import { Can } from 'providers/casl'

export const onGlobalSetupDefaultsPrebidAccess = (can: Can) => {
  can('access', 'GlobalSetupPage-defaults-prebid')
}

export const onGlobalSetupDefaultsPrebidUpdate = (can: Can) => {
  can('update', 'GlobalSetupFeature-defaults-prebid')
}
